"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServicesUrls = getServicesUrls;
var _getUrlsConfigurations = require("./getUrlsConfigurations");
var _transforms = require("./transforms");
/**
 * Returns URLs of all services available for the given tenant and environment
 * @param tenant Tenant
 * @param environment Environment in lowercase or uppercase
 * @param options Additional fetch options
 * @returns URLs of all services thansformed to a frontend-friendly format
 */
async function getServicesUrls(tenant, environment, options) {
  const servicesUrls = await (0, _getUrlsConfigurations.getUrlsConfigurations)(environment, tenant, options);
  return (0, _transforms.transformUrlsWithOverrides)(servicesUrls);
}
//# sourceMappingURL=getServicesUrls.js.map